import React from 'react';
import classNames from 'classnames';
import { Button, Icon, IconNames, Text } from '@dotcom/crown-ui';
import { FontSizeAction, FontSizeProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

export const FontSize = ({
  addClass = '',
  label,
  onClickButton,
  fontSizeValue,
  upper,
  lower,
  testId = 'font-size',
}: FontSizeProps): React.ReactElement => {
  const classes = classNames(styles['font-size'], addClass);

  const shouldDisabledRemoveButton = fontSizeValue === lower;
  const shouldDisabledAddButton = fontSizeValue === upper;

  return (
    <section className={classes} data-testid={testId}>
      <Text as="label">{label}</Text>
      <div className={styles.counter}>
        <Button
          testId="decreaseFontButton"
          disabled={shouldDisabledRemoveButton}
          variant="secondary"
          size="icon"
          onClick={() => onClickButton(FontSizeAction.Decrease)}
        >
          <Icon name={IconNames.Remove} />
        </Button>
        <Text as="span" color="textPrimary" className={styles['counterValue']}>
          {fontSizeValue}
        </Text>
        <Button
          testId="increaseFontButton"
          disabled={shouldDisabledAddButton}
          variant="secondary"
          size="icon"
          onClick={() => onClickButton(FontSizeAction.Increase)}
        >
          <Icon name={IconNames.Expand} />
        </Button>
      </div>
    </section>
  );
};
